import { useEffect, useState } from "react";
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../utils/firebase";
import { currency } from "../config/config";
import { getExpiryDate } from "../utils/Universalfunctions";
import { useUser } from "../context/UserContext";
import { handleCancelSubscriptionAdmin } from "../utils/handleCancelSubscriptionAdmin";

export const AdminUserList = () => {

     const { userData } = useUser();

     const [users, setUsers] = useState([]);
     const [loading, setLoading] = useState(true);


     const cancelForUser = async (targetUid) => {
          await handleCancelSubscriptionAdmin({
               targetUid,
               adminUid: userData?.uid,
               setLoading,
               onDone: () => alert("Cancelled for user"),
               onError: (e) => alert(e?.message || "Failed"),
          });
     };

     useEffect(() => {

          const fetchUsers = async () => {
               setLoading(true);
               try {
                    const usersRef = collection(db, "users");

                    // const q = query(usersRef, where("subscriptions", "in", ["paid", "payment_pending"]));
                    const q = query(usersRef, where("subscriptions", "in", ["paid", "payment_pending", "expired"]));

                    const snapshot = await getDocs(q);

                    if (!snapshot) {
                         console.warn("No snapshot returned from Firestore!");
                         setUsers([]);
                         return;
                    }

                    const userList = snapshot.docs?.map((doc) => {
                         const data = doc.data();
                         console.log(data)

                         return {
                              uid: doc.id,
                              totalEarnings: data?.totalEarnings,
                              name: data.name || "-",
                              email: data.email || "-",
                              status: data.subscriptions || "-",
                              planTitle: data?.planDetails?.planTitle || "-",
                              amountPaid: data?.planDetails?.amountPaid || "-",
                              planTimestamp: data?.planDetails?.planTimestamp || "-",
                              expired: data.subscriptions === "expired",
                              isPremium: data?.isPremium,
                         };
                    }) || [];

                    setUsers(userList);


               } catch (err) {
                    console.error("Error fetching users:", err);
                    setUsers([]); // safe fallback
               } finally {
                    setLoading(false);
               }
          };

          fetchUsers();
     }, []);


     // Toggle subscription ON/OFF
     const toggleSubscription = async (uid, currentStatus) => {
          try {
               const userRef = doc(db, "users", uid);

               // Toggle subscription and isPremium
               const newStatus = currentStatus === "paid" ? "expired" : "paid";
               const newPremium = newStatus === "paid";

               await updateDoc(userRef, {
                    subscriptions: newStatus,
                    isPremium: newPremium
               });

               // Update UI immediately
               setUsers((prev) =>
                    prev.map((u) =>
                         u.uid === uid
                              ? {
                                   ...u,
                                   status: newStatus,
                                   expired: newStatus === "expired",
                                   isPremium: newPremium
                              }
                              : u
                    )
               );
          } catch (err) {
               console.error("Error updating subscription:", err);
               alert("Failed to update subscription. Check console.");
          }
     };



     if (loading) return <p>Loading...</p>;

     return (
          <div>
               <div className="__tabledsd">
                    <h2>subscriptions List ({users.length})</h2>

                    <div className="table-responsive">
                         <table className="table table-dark table-borderless table-striped table-hover">
                              <thead>
                                   <tr>
                                        <th>action</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Earnings</th>
                                        <th>title</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Expires date</th>
                                        <th>Expired</th>
                                        <th>Cancel subscr</th>
                                   </tr>
                              </thead>
                              <tbody>
                                   {users.map((u) => (
                                        <tr key={u.uid}>

                                             <td>
                                                  <button
                                                       onClick={() => toggleSubscription(u.uid, u.status)}
                                                       style={{
                                                            backgroundColor: u.status === "paid" ? "green" : "red",
                                                            color: "#fff",
                                                            padding: "4px 10px",
                                                            border: "none",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                       }}
                                                  >
                                                       {u.status === "paid" ? "ON" : "OFF"}
                                                  </button>
                                             </td>
                                             <td>{u?.name} <br />
                                                  {u?.uid} <br />
                                                  Premium : {u?.isPremium ? <span class="badge bg-success">true</span> : <span class="badge bg-danger">false</span>}
                                             </td>
                                             <td>{u?.email}</td>
                                             <td>{currency}{u?.totalEarnings} </td>
                                             <td>{u?.planTitle} </td>
                                             <td>{u?.amountPaid} </td>
                                             <td>{u.status}</td>
                                             <td>
                                                  {(() => {
                                                       const d = getExpiryDate(u?.planTimestamp, u?.planTitle);
                                                       return d ? d.toLocaleDateString() : "-";
                                                  })()}
                                             </td>
                                             <td>
                                                  {u?.expired ?
                                                       <span class="badge bg-danger">YES</span> :
                                                       <span class="badge bg-secondary">NO</span>}
                                             </td>

                                             <td>
                                                  <button
                                                       style={{
                                                            backgroundColor: 'red',
                                                            color: "#fff",
                                                            padding: "4px 10px",
                                                            border: "none",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                       }}
                                                       disabled={loading} onClick={() => cancelForUser(u?.uid)}>
                                                       {loading ? "Cancelling..." : "Cancel (Admin)"}
                                                  </button>
                                             </td>

                                        </tr>
                                   ))}
                              </tbody>
                         </table>
                    </div>
               </div>
          </div>
     );
};